import { useEffect, useState } from 'react';
import axios from 'axios';
import { API, useAuth } from '../context/AuthContext';

// Which Reports section each report sits in for this tenant (defaults in
// backend feature_registry, moved per client from Super Admin), and which
// sections this login holds. `my_sections: null` means every section.
//
// The server enforces the same answer on every report route, so this only
// decides what is offered. One fetch per login, shared by the Reports page and
// global search; the 60s server cache makes a Super Admin move visible on the
// next page load.
let cache = { userId: null, promise: null };

const fetchSections = (userId) => {
  if (cache.userId !== userId || !cache.promise) {
    cache = {
      userId,
      promise: axios.get(`${API}/reports/sections`)
        .then((r) => r.data)
        .catch(() => {
          // Fail toward the catalogue's own tags rather than an empty tab; the
          // server still refuses anything this login may not open.
          cache = { userId: null, promise: null };
          return null;
        }),
    };
  }
  return cache.promise;
};

export default function useReportSections() {
  const { user } = useAuth();
  const userId = user?.id || user?.email || null;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    if (!userId) { setLoading(false); return undefined; }
    setLoading(true);
    fetchSections(userId).then((d) => {
      if (!alive) return;
      setData(d);
      setLoading(false);
    });
    return () => { alive = false; };
  }, [userId]);

  return { sectionsData: data, sectionsLoading: loading };
}
